/* GAEA-JS: 2026-10-01 — Actualiza el bloque de disponibilidad de entrega al cambiar de variante (evento variantChange del theme) */
(function () {
  if (window.__gaeaDeliveryAvailabilityBound) return;
  window.__gaeaDeliveryAvailabilityBound = true;

  function sync(payload) {
    var html = payload && payload.data && payload.data.html;
    if (!html) return;
    var fresh = html.querySelector('[data-delivery-availability]');
    if (!fresh || !fresh.id) return;
    var live = document.getElementById(fresh.id);
    if (live) live.innerHTML = fresh.innerHTML;
  }

  function init() {
    if (typeof subscribe !== 'function' || !window.theme || !theme.PUB_SUB_EVENTS) {
      console.warn('delivery-availability: pub/sub del theme no disponible');
      return;
    }
    subscribe(theme.PUB_SUB_EVENTS.variantChange, sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();